import React, { Component } from 'react';
import { Link } from 'react-router'
import { auth, fbProvider, db } from '../ThirdPartyIntegration/firebaseClient'
import TextField from 'material-ui/TextField';
import Button from 'material-ui/Button';
import Grid from 'material-ui/Grid';
import Paper from 'material-ui/Paper';
import Typography from 'material-ui/Typography';


class LoginComponent extends Component {
    constructor() {
        super();

        this.state = {
            email: "",
            password: ""
        }

        // This binding is necessary to make `this` work in the callback
        this.onClickLogin = this.onClickLogin.bind(this);
        this.onClickLoginWithFb = this.onClickLoginWithFb.bind(this);
        this.onChangeEmail = this.onChangeEmail.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
    }

    onClickLogin(e) {
        e.preventDefault();
        auth.signInWithEmailAndPassword(this.state.email, this.state.password).then(() => {
        }).catch((e) => {
            alert('login failed.');
            if (e.code === 'auth/invalid-email') {
                console.log('invalid email');
            } else if (e.code === 'auth/wrong-password') {
                console.log('invalid password');
            } else {
                console.log('login failed');
            }
        });
    }

    onClickLoginWithFb(e) {
        e.preventDefault();
        auth.signInWithPopup(fbProvider).then((result) => {
            let user = result.user;
            console.log(user);
            return db.ref().child(`users/${user.uid}/info`)
                .set({
                    username: user.displayName,
                    email: user.email,
                    uid: user.uid
                })
        }).catch((e) => {
            console.log('failed to login with facebook');
            console.log(e);
        });
    }

    onChangeEmail(e) {
        let v = e.target.value;

        // TODO: validate username and display errors
        if (!v) {
            console.log('email invalid');
        }

        this.setState({
            email: v
        });
    }

    onChangePassword(e) {
        let v = e.target.value;

        // TODO: validate password and display errors
        if (!v) {
            console.log('password invalid');
        }

        this.setState({
            password: v
        });
    }

    render() {
        let styles = {
            paper: {
                width: '70%',
                padding: '5%'
            },
            textfields: {
                width: '100%'
            },
            center: {
                textAlign: 'center'
            },
            link: {
                textDecoration: 'none'
            },
            button: {
                width: '100%'
            }
        }
        return (
            <Grid container justify="center" spacing={24}>
                <Grid item>
                    <img src="/logo96.png" alt="NDA" style={{ paddingTop: '20%' }} />
                </Grid>
                <Paper style={styles.paper} elevation={0}>
                    <Grid container spacing={8}>
                        <Typography type="headline" component="h3">
                            Login
                        </Typography>
                        <Grid item xs={12} style={styles.center}>
                            <TextField
                                id="email"
                                label="email"
                                value={this.state.email}
                                onChange={this.onChangeEmail}
                                style={styles.textfields}
                            />
                        </Grid>
                        <Grid item xs={12} style={styles.center}>
                            <TextField
                                id="password"
                                label="password"
                                value={this.state.password}
                                onChange={this.onChangePassword}
                                type="password"
                                autoComplete="current-password"
                                style={styles.textfields}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12} style={styles.center}>
                            <Button raised onClick={this.onClickLogin} color="accent" style={styles.button}>
                                Log in
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} style={styles.center}>
                            <Button raised onClick={this.onClickLoginWithFb} color="primary" style={styles.button}>
                                Facebook login
                            </Button>
                        </Grid>
                        <Grid item xs={12} sm={6} style={styles.center}>
                            <Link to="/join" style={styles.link}>
                                <Button raised onClick={this.onClickJoin} style={styles.button}>
                                    Join
                                </Button>
                            </Link>
                        </Grid>
                    </Grid>
                </Paper>
            </Grid>
        );
    }
}

export default LoginComponent;


// WEBPACK FOOTER //
// ./src/Components/login.jsx